import { Box, Image, Text, Tooltip } from '@wix/design-system';
import { CreativeOffer } from '@wix/premium-purchase-platform/@sdk';
import {
  ConfirmSmall,
  InfoCircleSmall,
} from '@wix/wix-ui-icons-common/odeditor';
import React from 'react';
import { StudioPackagePickerModule } from '../../../modules/studio-package-picker.module';

interface FeatureRowProps {
  row: CreativeOffer.MarketingFeature;
}

const transTags = { b: <b /> };
const transParams = { domainName: undefined };

export const FeatureRow = ({ row }: FeatureRowProps) => {
  const { t, Trans } = StudioPackagePickerModule.internals.useTranslations();

  if (!row.content?.localized) {
    return null;
  }

  const { translationKey, tooltipKey } = row.content.localized;
  const iconUrl = row.presentation?.style?.icon?.url;

  return (
    <Box direction="horizontal" width="100%" gap="8px" verticalAlign="top">
      <Box flexShrink="0">
        <ConfirmSmall />
      </Box>
      <Text size="small">
        <Trans
          i18nKey={translationKey}
          values={transParams}
          components={transTags}
        />
      </Text>
      {tooltipKey && (
        <Tooltip content={t(tooltipKey)}>
          <InfoCircleSmall color="var(--wsr-color-D40)" />
        </Tooltip>
      )}
      {iconUrl && (
        <Box inline position="relative">
          <Image src={iconUrl} width="18px" height="18px" transparent />
        </Box>
      )}
    </Box>
  );
};
